export const APPLICANT_PROFILE_UPDATES_PAGE_SIZE = 20

export const QA_NAME_APPLICANT_PROFILE_UPDATES = 'applicantProfileUpdates'

export const QA_NAME_APPLICANT_PROFILE_UPDATES_RETRY =
  'applicantProfileUpdatesRetry'
